import { Player } from 'modules/players/domain/interfaces/player';
import React, { useEffect, useMemo } from 'react';

import UDInput from 'ud-form/components/input/component';
import { UDCard } from 'ud-ui/components';
import UDHeaderTitle from 'ud-ui/components/header-title';
import UDPagination from 'ud-ui/components/pagination';
import UDPerPage from 'ud-ui/components/per-page/per-page';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';

import { usePlayersList } from 'modules/players/ui/hooks/use-players-list';

const PlayersTestPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();

  const { items, isLoading, isError, error, page, limit, totalPages, filters, setPage, setFilters, setPerPage } = usePlayersList();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Игроки (тест useOffsetPagination)</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  const listNode = useMemo(() => {
    if (isLoading) {
      return (
        <div className="flex flex-col gap-2">
          {Array.from({ length: limit }).map((_, i) => (
            <UDCard key={i}>
              <div className="skeleton-block mb-2" style={{ height: 16, width: '55%' }} />
              <div className="skeleton-block" style={{ height: 12, width: '35%' }} />
            </UDCard>
          ))}
        </div>
      );
    }

    if (isError) {
      return <div className="text-danger p-6 text-center">Ошибка: {String(error)}</div>;
    }

    if (items.length === 0) {
      return <div className="p-6 text-center">Нет данных</div>;
    }

    return (
      <div className="flex flex-col gap-2">
        {items.map((player: Player) => (
          <UDCard key={player.id}>
            <div className="fw-bold">
              {player.surname} {player.name}
            </div>
            {player.birthDate && (
              <div className="text-muted" style={{ fontSize: 13 }}>
                Дата рождения: {player.birthDate}
              </div>
            )}
            {(player.height || player.weight) && (
              <div className="text-muted" style={{ fontSize: 13 }}>
                {player.height && `Рост: ${player.height} см`}
                {player.height && player.weight && ', '}
                {player.weight && `Вес: ${player.weight} кг`}
              </div>
            )}
          </UDCard>
        ))}
      </div>
    );
  }, [isLoading, isError, error, items]);

  return (
    <div className="w-full px-6 py-6">
      <div className="mb-6 flex items-center gap-4">
        <UDInput
          placeholder="Поиск по имени..."
          value={filters.nameFilter ?? ''}
          onChange={(e) => setFilters({ nameFilter: e.target.value })}
          style={{ maxWidth: 300 }}
        />
        <UDPerPage style={{ marginLeft: 'auto' }} value={limit} onChange={setPerPage} />
      </div>

      {listNode}

      {totalPages > 1 && <UDPagination className="my-4 px-6" pages={totalPages} currentPage={page} onPageChange={setPage} />}
    </div>
  );
};

export default PlayersTestPage;
